/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Example_Output_LabelInputs */

const en_example_output_label = /** @type {(inputs: Example_Output_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Output`)
};

const ko_example_output_label = /** @type {(inputs: Example_Output_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`출력`)
};

const ja_example_output_label = /** @type {(inputs: Example_Output_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出力`)
};

/**
* | output |
* | --- |
* | "Output" |
*
* @param {Example_Output_LabelInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const example_output_label = /** @type {((inputs?: Example_Output_LabelInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Example_Output_LabelInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_example_output_label(inputs)
	if (locale === "ko") return ko_example_output_label(inputs)
	return ja_example_output_label(inputs)
});